import * as React from "react";

export interface LongProps {
    visible: boolean;
    children: React.ReactNode;
}

export function Long(props: LongProps): React.ReactElement {
    return <>{props.visible && props.children}</>;
}
